module.exports = __webpack_public_path__ + "static/media/logo.811c8fa8.png";